<template>
  <div class="app-container circle-list">
    <div class="circle-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="circle-list-filter-value" v-model.trim="listQuery.circleName" @keyup.enter.native="searchChange" clearable size="small" placeholder="名称"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="circle-list-filter-value" v-model="listQuery.isPublic" clearable size="small" placeholder="圈子类型">
              <el-option
                v-for="item in isPublicOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="circle-list-filter-value" v-model="listQuery.isActive" clearable size="small" placeholder="状态">
              <el-option
                v-for="item in isActiveOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-date-picker
              class="circle-list-filter-date"
              v-model="listQuery.createTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small"
              placeholder="创建时间">
            </el-date-picker>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-button class="circle-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="circle-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud ref="crud"
                 :page.sync="page"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @current-change="currentChange"
                 @size-change="sizeChange"
                 @sort-change="sortChange"
                 @row-del="rowDel">

        <template slot="postCount"
                  slot-scope="scope">
            {{scope.row.postCount}}
        </template>

        <template slot="menuLeft">
          <el-button type="primary"
                     @click="handleAdd"
                     icon="el-icon-add"
                     size="small"
                     v-if="permissions.circle_add">创建圈子</el-button>
          <br /><br />
        </template>
        <template slot-scope="scope"
                  slot="menu">
          <el-button type="text"
                     v-if="permissions.circle_view"
                     icon="el-icon-view"
                     size="mini"
                     @click="handleView(scope.row,scope.index)">查看</el-button>
          <el-button type="text"
                     v-if="permissions.circle_del && scope.row.isActive"
                     icon="el-icon-download"
                     size="mini"
                     @click="handleDel(scope.row,scope.index)">下架</el-button>
          <el-button type="text"
                     v-if="permissions.circle_del && !scope.row.isActive"
                     icon="el-icon-upload2"
                     size="mini"
                     @click="handleDel(scope.row,scope.index)">上架</el-button>
          <el-button type="text"
                     v-if="permissions.circle_edit"
                     icon="el-icon-edit"
                     size="mini"
                     @click="handleEdit(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
                     v-if="permissions.circle_edit"
                     icon="el-icon-sort"
                     size="mini"
                     @click="handleSort(scope.row,scope.index)">排序</el-button>
        </template>
      </avue-crud>
    </basic-container>
    <el-dialog title="排序设置" :visible.sync="dialogSortVisible" width="30%" class="sort-dialog">
      <div class="sort-dialog-item">
        <label class="sort-dialog-item-label">顺序：</label>
        <el-input v-model.trim="circleSort.sort" type="number" class="sort-dialog-item-input" clearable></el-input>
      </div>
      <div class="sort-dialog-footer">
        <el-button type="primary" class="sort-dialog-footer-save" @click="modifySortRule">修改</el-button>
        <el-button class="sort-dialog-footer-cancel" @click="dialogSortVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { fetchList, setActive, setPublic, updateCircleSort } from '@/api/post/circle'
  import { tableOption, isPublicOptions, isActiveOptions } from '@/const/crud/post/circle'
  import { mapGetters } from 'vuex'
  export default {
    name: 'circle',
    data() {
      return {
        tableData: [],
        page: {
          total: 0, // 总记录数
          currentPage: 1, // 当前页数
          pageSize: 10 // 每页显示多少条
        },
        listQuery: {
          current: 1,
          size: 10,
          circleType: 0,
          circleName: '',
          ownerName: '',
          isPublic: '',
          isActive: '',
          createTime: [],
          sortField: 'inserted_time',
          sortPolicy: 'desc'
        },
        tableLoading: false,
        tableOption: tableOption,
        isPublicOptions: isPublicOptions,
        isActiveOptions: isActiveOptions,
        dialogSortVisible: false,
        circleSort: {},
      }
    },
    mounted: function() {
      this.getList()
      // this.getTagOptions()
    },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.listQuery.createTime && this.listQuery.createTime.length > 0) {
          return this.listQuery.createTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.listQuery.createTime && this.listQuery.createTime.length > 1) {
          return this.listQuery.createTime[1]
        } else {
          return null
        }
      }
    },
    methods: {
      // getTagOptions() {
      //   getTagsByType({type: 3}).then(response => {
      //     if (Array.isArray(response.data.data)) {
      //       this.tagOptions = response.data.data.map(x => {
      //         return {
      //           tagId: x.id,
      //           tagName: x.name
      //         }
      //       })
      //     }
      //   })
      // },
      getList() {
        this.tableLoading = true
        if (this.startTime && this.endTime) {
          this.listQuery.startTime = this.startTime
          let t = new Date(this.endTime)
          t.setDate(t.getDate() + 1)
          this.listQuery.endTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          this.listQuery.startTime = null
          this.listQuery.endTime = null
        }
        fetchList(this.listQuery).then(response => {
          this.tableData = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.tableLoading = false
        }).catch(error => {
          console.error(error)
          this.$message({
            message: '获取圈子列表失败',
            type: 'error'
          })
          this.tableLoading = false
        })
      },
      formatData(records) {
        if (Array.isArray(records)) {
          records.forEach(circle => {
            circle.publicText = circle.isPublic ? '公有' : '私有'
            circle.activeText = circle.isActive ? '已上架' : '已下架'
            if (circle.postCount == null) circle.postCount = 0
            if (circle.memberCount == null) circle.memberCount = 0
          })
        }
        return records
      },
      searchReset() {
        this.listQuery.circleName = ''
        this.listQuery.ownerName = ''
        this.listQuery.isPublic = ''
        this.listQuery.isActive = ''
        this.listQuery.createTime = []
        this.searchChange()
      },
      searchChange() {
        this.page.currentPage = 1
        this.listQuery.current = 1
        this.getList()
      },
      currentChange(val) {
        this.page.currentPage = val
        this.listQuery.current = val
        this.getList()
      },
      sizeChange(val) {
        this.page.currentPage = 1
        this.listQuery.current = 1
        this.page.pageSize = val
        this.listQuery.size = val
        this.getList()
      },
      handleAdd: function() {
        this.$router.push({
          path: '/post/circle/add'
        })
      },
      handleEdit(row, index) {
        this.$router.push({
          path: `/post/circle/edit/${row.id}`,
        })
      },
      handleDel(row, index) {
        this.$refs.crud.rowDel(row, index)
      },
      handleSort(row, index) {
        this.dialogSortVisible = true;
        this.circleSort = {
          circleId: row.id,
          sort: row.sort,
        }
      },
      modifySortRule() {
        updateCircleSort(this.circleSort).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: '修改排序成功',
              type: 'success'
            });
            this.getList();
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: '修改排序失败',
            type: 'error'
          });
        }).finally(() => {
          this.dialogSortVisible = false;
        });
      },
      handlePublic(row, index) {
        setPublic(row.id).then((response) => {
          if (response.data.data) {
            if (row.isPublic === false) {
              row.isPublic = true
              row.publicText = '公有'
            } else {
              row.isPublic = false
              row.publicText = '私有'
            }
            this.$message({
              showClose: true,
              message: '更新成功',
              type: 'success'
            })
          } else {
            this.$message({
              showClose: true,
              message: '更新失败',
              type: 'error'
            })
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            showClose: true,
            message: '更新失败',
            type: 'error'
          })
        })
      },
      handleView(row, index) {
        this.$router.push({
          path: `/post/circle/detail/${row.id}`
        })
      },
      rowDel: function(row, index) {
        var _this = this
        const context = row.isActive ? '下架' : '上架';
        this.$confirm(`是否确认${context}圈子：` + row.circleName + ' ?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          setActive(row.id).then(response => {
            if (response.data.data) {
              if (row.isActive === 1) {
                row.isActive = 0
                row.activeText = '已下架'
                _this.$message({
                  showClose: true,
                  message: '下架成功',
                  type: 'success'
                })
              } else {
                row.isActive = 1
                row.activeText = '已上架'
                _this.$message({
                  showClose: true,
                  message: '上架成功',
                  type: 'success'
                })
              }
            }
          }).catch(function(err) {
            console.error(err)
            _this.$message({
              showClose: true,
              message: '操作失败',
              type: 'error'
            })
          })
        })
      },
      sortChange (val) {
        // 检查排序对象
        if (val.prop === 'id') {
          this.listQuery.sortField = 'id';
        } else if (val.prop === 'createdTime') {
          this.listQuery.sortField = 'inserted_time';
        } else if (val.prop === 'postCount') {
          this.listQuery.sortField = 'post_count';
        } else if (val.prop === 'memberCount') {
          this.listQuery.sortField = 'member_count';
        } else if (val.prop === 'sort') {
          this.listQuery.sortField = 'sort';
        }
        // 检查排序方式
        if (val.order == 'ascending') {
          this.listQuery.sortPolicy = "asc";
        } else if (val.order == 'descending') {
          this.listQuery.sortPolicy = "desc";
        } else {
          this.listQuery.sortPolicy = "";
        }
        this.getList();
      },
      toMemberDetail(ownerId) {
        this.$router.push({
          path: "/upms/member/detail/" + ownerId,
        })
      },
      toPostList(id) {
        this.$router.push({
          path: "/post/posts",
          query: {
            circleId: id
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
.circle-list {
  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 22px;

    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }

    &-value {
      width: 96%!important;
    }

    &-date {
      width: 96%!important;
    }

    &-reset {
      float: right;
      margin-right: 8px;
    }

    &-search {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
.sort-dialog {
  display: flex;
  flex-direction: column;
    &-item {
      width: 500px;
      display: flex;
      flex-direction: row;
      &-label {
        text-align: center;
        font-size: 14px;
        width: 50px;
        line-height: 36px;
        padding: 0 5px;
      }
      &-input {
        font-size: 14px;
        width: 300px;
        height: 36px;
      }
    }
    &-footer{
      display: flex;
      flex-direction: row;
      padding: 20px 0px;
      &-save {
        padding: 8px 12px;
        position: absolute;
        right: 90px;
      }
      &-cancel {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        margin-right: 10px;
      }
    }
  }
</style>

